// extracted by mini-css-extract-plugin
module.exports = {"options-block":"button-menu_options-block__2tGu9","link":"button-menu_link__26Jr8","disabled":"button-menu_disabled__1N5B7","btn":"button-menu_btn__12k0g"};